import styled from 'styled-components';
import { ReactComponent as TemplateSVG } from 'Images/template.svg';

export const TemplateIcon = styled(TemplateSVG)`
  & > g {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
TemplateIcon.displayName = 'TemplateIcon';

export default TemplateIcon;
